import axios from 'axios';
import { getAuthToken } from '../utils/auth';

const API_URL = process.env.REACT_APP_API_URL + 'products';

const getHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${getAuthToken()}`
});

export const getProducts = async () => {
  const response = await axios.get(API_URL, { headers: getHeaders() });
  return response.data;
};

export const createProduct = async (productData) => {
  const response = await axios.post(API_URL, productData, { headers: getHeaders() });
  return response.data;
};

export const updateProduct = async (id, productData) => {
  const response = await axios.put(`${API_URL}/${id}`, productData, { headers: getHeaders() });
  return response.data;
};

export const deleteProduct = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`, { headers: getHeaders() });
  return response.data;
};

export const updateOrder = async (products) => {
  const response = await axios.put(`${API_URL}/reorder`, { products }, { headers: getHeaders() });
  return response.data;
};
